import React, { FC, ReactNode } from 'react';
import {
  ContainerDesktop,
  ContainerMobile,
  Content,
  FieldTitle,
  Link,
  FieldText,
} from './ActionBlock.style';
import useMedia from 'hooks/useMedia';

interface DataViewProps
  extends Omit<
    React.HTMLAttributes<HTMLDivElement>,
    'dangerouslySetInnerHTML'
  > {
  fieldTitle?: string;
  fieldValue?: any;
  dataModifyLink?: ReactNode | string;
  onClickHandler?: (any) => void;
  dataRedirectionLink?: string;
  dataHref?: any;
}

const RightHandler = ({
  onClickHandler,
  dataModifyLink,
  dataHref,
  dataRedirectionLink,
}) => {
  if (!onClickHandler && dataModifyLink) {
    return <>{dataModifyLink}</>;
  }
  if (onClickHandler && dataModifyLink) {
    return <Link onClick={onClickHandler}>{dataModifyLink}</Link>;
  }

  return <Link href={dataHref}>{dataRedirectionLink}</Link>;
};

const ActionBlock: FC<DataViewProps> = ({
  fieldTitle,
  fieldValue,
  dataModifyLink,
  onClickHandler,
  dataRedirectionLink,
  dataHref,
  ...rest
}) => {
  const isMobile = useMedia('(max-width: 62rem)');
  const Container = isMobile ? ContainerMobile : ContainerDesktop;

  return (
    <Container {...rest}>
      {fieldTitle && (
        <FieldTitle data-test-field-title>{fieldTitle}</FieldTitle>
      )}
      <Content>
        {fieldValue && <FieldText data-test-field-text>{fieldValue}</FieldText>}
        <RightHandler
          dataModifyLink={dataModifyLink}
          onClickHandler={onClickHandler}
          dataRedirectionLink={dataRedirectionLink}
          dataHref={dataHref}
        />
      </Content>
    </Container>
  );
};

export default ActionBlock;
